import { Components, Theme } from "@mui/material";

export const MuiFormControl: Components<
  Omit<Theme, "MuiFormControl">
>["MuiFormControl"] = {
  styleOverrides: {
    root: ({ theme: { palette, spacing } }) => ({
      "& .MuiInputLabel-root": {
        color: palette.text.secondary,

        "&.MuiInputLabel-shrink": {
          paddingLeft: 3,
          marginTop: 18,
        },
      },

      "& legend": {
        width: 0,
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: "#E9E9E9",
      },

      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },

      "& .MuiListItemIcon-root": {
        minWidth: spacing(5),
      },
    }),
  },
};
